import type {
  INeoConversationController,
  INeoConversationService,
} from "../../core/ports/driver/neoConversationService";

export const NeoConversationControllerFactory = ({
  neoConversationService,
}: {
  neoConversationService: INeoConversationService;
}): INeoConversationController => ({
  listConversations: neoConversationService.listConversations,
  listConversationActivity: neoConversationService.listConversationActivity,
  markConversationViewed: neoConversationService.markConversationViewed,
  getConversationHistory: neoConversationService.getConversationHistory,
  updateConversationTitle: neoConversationService.updateConversationTitle,
  createConversation: neoConversationService.createConversation,
  deleteConversation: neoConversationService.deleteConversation,
  uploadFile: neoConversationService.uploadFile,
  streamTurn: neoConversationService.streamTurn,
  cancelMessage: neoConversationService.cancelMessage,
});
